module.exports = __webpack_public_path__ + "6b1882948eb7b246709d6455db31a583.pdf";